import {
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  Box,
} from '@chakra-ui/react'
import React, { ReactNode } from 'react'

type TimeTableProps = {
  children: ReactNode;
  maxHeight?: string;
}

const TimeTable: React.FC<TimeTableProps> = ({ children, maxHeight = "calc(100vh - 520px)" }) => {
  const isMobile = useBreakpointValue({ base: true, md: false })
  
  return (
    <Box border="1px solid" borderColor="gray.200" borderRadius="md">
      <TableContainer 
        overflowX="auto" 
        overflowY="auto" 
        maxHeight={maxHeight}
        sx={{
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
            borderRadius: '8px',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
          },
        }}
      >
        <Table variant="simple" sx={{ tableLayout: "fixed", width: "100%" }}>
          <Thead
            boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
            position="sticky"
            top="0"
            zIndex="docked"
            backgroundColor="gray.50"
          >
            <Tr borderBottomWidth="1px" borderBottomColor="gray.200">
              <Th
                w={isMobile ? "100px" : "100px"}
                borderRightWidth="1px"
                borderRightColor="gray.200"
                textAlign="center"
                px={2}
                backgroundColor="gray.50"
              >
                時間
              </Th>
              <Th 
                textAlign="center" 
                px={2} 
                backgroundColor="gray.50"
              >
                選択
              </Th>
            </Tr>
          </Thead>
          <Tbody>{children}</Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default TimeTable 